import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import KeysTable from './KeysTable';
import { wrapTemplateKey, type TemplateKeyRow } from '../keysUtils';
import { DOCUMENT_TEMPLATE_KEYS } from '../../model/buildDocumentTemplateValueKeys';

interface DocumentKeysTabProps {
    onKeySelect?: (key: string) => void;
}

const DocumentKeysTab = ({ onKeySelect }: DocumentKeysTabProps) => {
    const { t } = useTranslation('TemplateValueKeys');

    const rows = useMemo<TemplateKeyRow[]>(
        () =>
            DOCUMENT_TEMPLATE_KEYS.map((name) => ({
                key: wrapTemplateKey(name),
                value: t(`directory.document.${name}`),
            })),
        [t],
    );

    return <KeysTable rows={rows} onKeySelect={onKeySelect} />;
};

export default DocumentKeysTab;
